module.exports = __webpack_public_path__ + "static/media/sb-logo-light.0521d2d5.svg";